export default __webpack_public_path__ + "static/media/roast.bc1f0254.PNG";